import React from 'react';
import classNames from 'classnames';

import QR from '@material-ui/icons/BlurOn';
import { BlueRightArrowIcon } from '../../../../images/icons/WrapSvg';

class Local extends React.Component {

    handleClick = (event) => {
        this.props.history.push('/manage/locals/' + this.props.data.id);
    };

    render() {
        const { data, last } = this.props;

        return (
            <div
                className={'flex_full_row padding_top_24 padding_left_12 margin_left_24 c_grey_blue hand '}
                onClick={this.handleClick}
            >
                <div
                    className={classNames(
                        'flex_full_row  align_center padding_bottom_9',
                        last ? 'noshadow' : 'shadow_down',
                    )}
                >
                    <div className={'flex_full_row'}>
                        <span className="flex_full_row barlow_medium c_dark_grey_blue uppercase">
                            {data.nombre}
                        </span>
                        <QR className={"margin_right_12 " + (data.codigoPublico ? "c_pea" : "c_lipstick")} />
                    </div>
                    <BlueRightArrowIcon color="primary" />
                </div>
            </div>
        );
    }
}

export default Local;



// WEBPACK FOOTER //
// ./src/components/complex/manage/locals/Local.js